// Données structurées Schema.org. Elles décrivent l'entreprise et les pages
// pour Google (extraits enrichis, panneau local, fil d'Ariane).
//
// Règle de conformité (courrier ANAH) : 22 000 € est un PLAFOND DE TRAVAUX,
// jamais un montant d'aide. L'aide maximale est de 15 400 € (70 %).
// Aucun partenariat France Rénov' ne doit être revendiqué ici.

export const SITE = "https://transition-energie-france.fr";

// Exporté : les pages qui affichent la zone d'intervention lisent cette liste
// plutôt que de la recopier, pour qu'une nouvelle habilitation n'ait à être
// ajoutée qu'à un seul endroit.
export const DEPARTEMENTS_COUVERTS = [
  { nom: "Paris", code: "75" },
  { nom: "Seine-et-Marne", code: "77" },
  { nom: "Essonne", code: "91" },
  { nom: "Hauts-de-Seine", code: "92" },
  { nom: "Seine-Saint-Denis", code: "93" },
  { nom: "Val-d'Oise", code: "95" },
];

// Fiche entreprise, injectée sur toutes les pages
export const entrepriseJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": `${SITE}/#entreprise`,
  name: "Transition Énergie France",
  // Identité formelle : une société homonyme (« Groupe Transition Énergie »,
  // à Clichy) capte des recherches destinées à celle-ci et provoque des appels
  // mal orientés. Le SIREN et les liens vers les registres officiels
  // permettent à Google de distinguer les deux entités.
  legalName: "TRANSITION ENERGIE FRANCE",
  identifier: {
    "@type": "PropertyValue",
    propertyID: "SIRET",
    value: "88008469400046",
  },
  sameAs: [
    "https://annuaire-entreprises.data.gouv.fr/entreprise/transition-energie-france-880084694",
    "https://www.societe.com/societe/transition-energie-france-880084694.html",
    "https://maps.app.goo.gl/xQ5BERBaeQsyFwFcA",
  ],
  description:
    "Assistant à maîtrise d'ouvrage (AMO) agréé ANAH, spécialiste de MaPrimeAdapt' et de l'adaptation du logement des seniors et des personnes en situation de handicap en Île-de-France.",
  url: SITE,
  logo: `${SITE}/images/logo-tef.jpg`,
  image: `${SITE}/images/logo-tef.jpg`,
  telephone: "+33939035444",
  email: "contact@transition-energie-france.fr",
  priceRange: "Accompagnement AMO pris en charge par l'ANAH",
  address: {
    "@type": "PostalAddress",
    streetAddress: "99 avenue Achille Peretti",
    postalCode: "92200",
    addressLocality: "Neuilly-sur-Seine",
    addressRegion: "Île-de-France",
    addressCountry: "FR",
  },
  areaServed: DEPARTEMENTS_COUVERTS.map((d) => ({
    "@type": "AdministrativeArea",
    name: `${d.nom} (${d.code})`,
  })),
  knowsAbout: [
    "MaPrimeAdapt'",
    "Adaptation du logement au vieillissement",
    "Accessibilité PMR",
    "Assistance à maîtrise d'ouvrage ANAH",
  ],
  // Horaires réels, ceux du pied de page, de la page contact et des créneaux
  // de rappel (voir utils/creneaux.js). Ils annonçaient 9h-18h du lundi au
  // vendredi : Google affichait donc l'entreprise comme ouverte le vendredi
  // après-midi, où elle est fermée.
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday"],
      opens: "10:00",
      closes: "17:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Friday"],
      opens: "10:00",
      closes: "13:00",
    },
  ],
});

// Service décrit sur une page donnée.
// `zones` restreint la zone desservie : sur une page départementale, annoncer
// les 6 départements brouille le signal local, on ne déclare que celui-ci.
export const serviceJsonLd = ({ nom, description, url, zones }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name: nom,
  description,
  url: `${SITE}${url}`,
  serviceType: "Assistance à maîtrise d'ouvrage MaPrimeAdapt'",
  provider: { "@id": `${SITE}/#entreprise` },
  areaServed: (zones || DEPARTEMENTS_COUVERTS).map((d) => ({
    "@type": "AdministrativeArea",
    name: `${d.nom} (${d.code})`,
  })),
});

// Fil d'Ariane : [{ nom, url }] en partant de l'accueil
export const filArianeJsonLd = (etapes) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: etapes.map((e, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: e.nom,
    item: `${SITE}${e.url}`,
  })),
});

// Questions/réponses : rend la page éligible aux extraits enrichis FAQ
export const faqJsonLd = (questions) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: questions.map((q) => ({
    "@type": "Question",
    name: q.question,
    acceptedAnswer: { "@type": "Answer", text: q.answer },
  })),
});
